import { registerWidget } from '../../common/functions/register-widget'
import { renderWidget } from '../../common/functions/render-vue-widget'
import { isDone, isObjectEmpty } from '../../util'

import Packages from './packages.vue'

import {
  packagesContentEditor,
  packagesDesignEditor,
} from './packages.widget.mock'

export function init ({ container, props, ...additionalData }) {
  
  // Mocking data on localhost
  if(location.hostname === 'localhost') {
    props = {
      ...packagesContentEditor,
      ...packagesDesignEditor,
    }

    additionalData = {
    }
  }

  isDone().then(() => {
    additionalData = !isObjectEmpty(additionalData)
      ? additionalData
      : {}

    renderWidget({
      container,
      name: 'ae-widget-packages',
      component: Packages,
      config: { ...props, ...additionalData },
      ignored: [ 'ae-package-list' ]
    })
  })
}

export function clean ({ container }) {
  container.innerHTML = ''
}

registerWidget('packages', init, clean)
